import styled from 'styled-components';

import { DEFAULT_COLORS } from 'constants/colors';

const LoginErrors = styled.div`
    background-color: ${DEFAULT_COLORS.LOGIN_ERROR_BACKGROUND};
    border: 1px solid ${DEFAULT_COLORS.RED_2};
    color: ${DEFAULT_COLORS.RED_2};
    margin: 0 0 20px;
    padding: 20px;
    width: 100%;
`;

export default LoginErrors;
